







































import { Component, Vue } from 'vue-property-decorator';

import { APP_CONFIG } from '@/config/app-config';

import Withdrawal from './components/Withdrawal.vue';
import Recharge from './components/Recharge.vue';
import WalletInfo from './components/WalletInfo.vue';
// import RechargeHistories from './components/RechargeHistories.vue';
// import WithDrawalHistories from './components/WithdrawalHistories.vue';
import WalletHistories from './components/WalletHistories.vue';
import TradeHistories from './components/TradeHistories.vue';

@Component({
    components: {
        'with-drawal': Withdrawal,
        're-charge': Recharge,
        'wallet-info': WalletInfo,
        // 'recharge-histories': RechargeHistories,
        // 'withdrawal-histories': WithDrawalHistories,
        'wallet-histories': WalletHistories,
        'trade-histories': TradeHistories
    }
})
export default class Credit extends Vue {
    private tabs = {
        withDrawal: 'withDrawal',
        reCharge: 'reCharge'
    }

    private selectedTab = this.tabs.reCharge;
    private onReCharge: boolean = false;
    private isShowTradeHistories = false;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    private async onSelectTab(tab: any) {
        this.selectedTab = tab;
    }

    private async reCharge() {
        this.onReCharge = !this.onReCharge;
    }

    private async onShowTradeHistories(data: any) {
        this.isShowTradeHistories = true;
    }

    private async onCloseTradeHistories(data: any) {
        this.isShowTradeHistories = false;
    }
}
